export enum ACTION {
  NEW_EMAIL = "NEW",
  EDIT_EMAIL = "EDIT",
  DELETE_EMAIL = "DELETE",
}
